import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { PublicAppFooter } from '../../PublicAppFooter'
import PublicAppHeader from '../../PublicAppHeader'
import { ProfileCard } from './BoardMemberProfile'
import { ProfileContainer } from './stylecomponent'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

export default function GuestMemberProfile()  {

  const { slug } = useParams()

  const [guestData, setGuestData] = useState(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const getAndSetGuests = async () => {
    const res = await getDataWithParams(`/api/guest/details`, {slug : slug})
    setLoading(false)
    if (res?.status === 200 && res?.data) {
      setGuestData(res?.data)
    } else {
      navigate('/404')
    }
  }

  useEffect(() => {
    getAndSetGuests()
  }, [])

  return (
    <>   
     <PublicAppHeader config={{ showLinks: true }} />
      <SEOComponent
        title={guestData?.title || 'AUMHUM'}
        description={guestData?.description || 'Podcast guest'}
        image={guestData?.coverIcon ? getImageLink(guestData?.coverIcon) : APP_CONSTANTS.GUEST_LISTING_IMAGE_LINK}
        keywordsArr={['Guests']}
      />
      <div style={{ maxWidth: '85%' }} className="p-4 mx-auto d-flex justify-content-center">
        {loading ? (
          <Spinner />
        ) : (
            <ProfileContainer key={`${guestData?.id}`} className="shadow p-3 rounded-lg m-4">
              <ProfileCard
                name={guestData?.title}
                description={guestData?.description}
                img={guestData?.coverIcon}
              />
            </ProfileContainer>
          )
}
      </div>
      <PublicAppFooter />
    </>
  )
}